import { defineMessages } from 'react-intl';

const messages = defineMessages({
  home: {
    id: 'clubskpLoggedIn.home',
    defaultMessage: 'Home',
    description: 'clubskpLoggedIn.home',
  },
  rewards: {
    id: 'clubskpLoggedIn.rewards',
    defaultMessage: 'Clubskp',
    description: 'clubskpLoggedIn.rewards',
  },
  points: {
    id: 'clubskpLoggedIn.points',
    defaultMessage: 'Points Earned',
    description: 'clubskpLoggedIn.points',
  },
  orders: {
    id: 'clubskpLoggedIn.orders',
    defaultMessage: 'Orders',
    description: 'clubskpLoggedIn.orders',
  },
  activities: {
    id: 'clubskpLoggedIn.activities',
    defaultMessage: 'Activities',
    description: 'clubskpLoggedIn.activities',
  },
  content: {
    id: 'clubskpLoggedIn.content',
    defaultMessage: "Member's Lounge",
    description: 'clubskpLoggedIn.content',
  },
  news: {
    id: 'clubskpLoggedIn.news',
    defaultMessage: 'News',
    description: 'clubskpLoggedIn.news',
  },
  education: {
    id: 'clubskpLoggedIn.education',
    defaultMessage: 'Education',
    description: 'clubskpLoggedIn.education',
  },
  products: {
    id: 'clubskpLoggedIn.products',
    defaultMessage: 'Products',
    description: 'clubskpLoggedIn.products',
  },
});

export default {
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [
    { text: 'CLUB', color: '#ec2027' },
    { text: 'SKP', color: '' },
  ],
  links(group, siteId, intl) {
    return [
      {
        iconClass: 'left-nav-icons left-nav-icons--home',
        title: intl.formatMessage(messages.home),
        to: ['home'],
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--rewards',
      //   title: intl.formatMessage(messages.rewards),
      //   target: null,
      //   to: ['rewards'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--expenses',
      //   title: intl.formatMessage(messages.points),
      //   to: ['clubskp-points'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--products',
      //   title: intl.formatMessage(messages.orders),
      //   to: ['clubskp-orders'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--activities',
      //   title: intl.formatMessage(messages.activities),
      //   to: ['clubskp-activities'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--user',
      //   title: intl.formatMessage(messages.content),
      //   to: ['clubskp-content'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--skp',
      //   title: 'How It Works',
      //   to: ['about'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--news',
      //   title: intl.formatMessage(messages.news),
      //   to: ['news'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--education',
      //   title: intl.formatMessage(messages.education),
      //   to: ['education'],
      //   links: false,
      // },
      {
        iconClass: 'left-nav-icons left-nav-icons--products',
        title: intl.formatMessage(messages.products),
        target: '_blank',
        to:
          siteId === 'ca'
            ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html'
            : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--promotions',
      //   title: 'Promotions',
      //   to: ['page', { slug: 'promotions' }],
      //   links: false,
      // },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sidebar/clubskpLoggedIn.js